import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

const environment = process.env.REACT_APP_ENVIRONMENT ?? 'local';

if (environment !== 'local') {
  Sentry.init({
    dsn: 'https://a6350353dc8cfc81ff0f27ba20352f61@o4509712044130304.ingest.us.sentry.io/4509712067395584',
    sendDefaultPii: true,
    debug: !Boolean(process.env.REACT_APP_ENVIRONMENT),
    environment: process.env.REACT_APP_ENVIRONMENT ?? 'local',
    release: process.env.REACT_APP_VERSION ?? 'local',
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
